export const workflowIssues = [
    {
        icon: '/img/slow processing.png',
        title: 'Slow processing',
    },
    {
        icon: '/img/lack of transparency.png',
        title: 'Lack of transparency',
    },
    {
        icon: '/img/Inefficient assessments.png',
        title: 'Inefficient assessments',
    },
    {
        icon: '/img/Underestimated value.png',
        title: 'Underestimated value',
    },
    {
        icon: '/img/Messy records.png',
        title: 'Messy records',
    }
];

export const builtForList = [
    {
        icon: '/img/AI-powered Damage Detection remarketing.png',
        title: 'AI-powered Damage Detection',
    },
    {
        icon: '/img/Validate resale readiness.png',
        title: 'Validate resale readiness',
    },
    {
        icon: '/img/Instant condition report remarketing.png',
        title: 'Instant condition report',
    },
    {
        icon: '/img/List faster.png',
        title: 'List faster. Sell Smarter',
    },
    {
        icon: '/img/No additional Hardware.png',
        title: 'No additional Hardware needed',
    }
];

export const stats = [
    {
        value: '70%',
        label: 'Faster time to List'
    },
    {
        value: '15-20%',
        label: 'Higher resale value'
    },
    {
        value: '100%',
        label: 'Transparency Inspection History'
    },
    {
        value: '80%',
        label: 'Lesser buyer disputes'
    }
];

export const capabilities = [
    {
        icon: '/img/Automate inbound inspection.png',
        title: 'Automate Inbound Inspections during the buying process',
        text: ''
    },
    {
        icon: '/img/easy to share condition report.png',
        title: 'AI-powered & easy to share condition report',
        text: ''
    },
    {
        icon: '/img/close deals faster.png',
        title: 'AI-powered pricing to help close deals faster',
        text: ''
    },
    {
        icon: '/img/Standarized pricing.png',
        title: 'Standardized pricing across all makes & models based on market data',
        text: ''
    }
];

